package kz.dentalcrm.app.screens.protocols.edit.mvi

import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate

data class EditProtocolViewState(
    val screenState: ScreenState = ScreenState.Idle,
    val protocolTemplate: ProtocolTemplate? = null
) : ViewState {
    sealed interface ScreenState {
        data class Error(val error: String) : ScreenState
        data object Idle : ScreenState
        data object Edited : ScreenState
        data object Deleted : ScreenState
        data object Editing : ScreenState
        data object Loading : ScreenState
    }
}
